import { useLocation } from '../../app/route';

export function useQueryUserId() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  return query.get('id') || '';
}
